import React, { useRef, useState } from "react";
import domtoimage from "dom-to-image";
import { Button, Card, Col, Modal, Row, Typography } from "antd";
import Card1 from "../idCards/Card1";
import CardDefault from "../idCards/CardDefault";
import Card2 from "../idCards/Card2";
import Card3 from "../idCards/Card3";
import Card4 from "../idCards/Card4";

const IdCard = ({
  isModalOpen,
  setIsModalOpen,
  title,
  profile,
  company,
  candidateName,
  studentClass,
  studentSection,
  displayNumber,
  qrData,
  mobile,
  logo,
  studentAdmission,
  fathersName,
  schoolName,
  schoolMobile,
  schoolAddress,
  cardType
}) => {
  const [processing, setProcessing] = useState();
  const qrCodeRef = useRef();

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleDownload = () => {
    if (qrCodeRef.current) {
      domtoimage
        .toBlob(qrCodeRef.current, {
          cacheBust: true,
          bgcolor: "white",
          useCORS: true, // Ensures images from other origins are included
        })
        .then((blob) => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = `${qrData.qr_code || "unknown"}.png`;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating image:", error);
        });
    }
  };

  const handlePrint = () => {
    if (qrCodeRef.current) {
      domtoimage
        .toPng(qrCodeRef.current)
        .then((dataUrl) => {
          const newWindow = window.open("", "_blank");
          newWindow.document.write(`
                            <html>
                                <head><title>Print Gate Pass</title></head>
                                <body style="text-align: center;">
                                    <img src="${dataUrl}" style="width: 300px;" />
                                    <script>window.onload = function() { window.print(); window.onafterprint = function() { window.close(); }; }</script>
                                </body>
                            </html>
                        `);
          newWindow.document.close();
        })
        .catch((error) =>
          console.error("Error generating print image:", error)
        );
    }
  };

  return (
    <div>
      <Modal
        open={isModalOpen}
        title={title}
        onCancel={handleCancel}
        centered
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="print"
            type="primary"
            loading={processing}
            onClick={handlePrint}
            className="form-btn"
          >
            Print
          </Button>,
          <Button
            key="download"
            type="primary"
            loading={processing}
            onClick={handleDownload}
            className="form-btn"
          >
            Download
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            padding: 20,
            backgroundColor: "#f9f9f9",
            borderRadius: 10,
          }}
        >
          {cardType == 1 ? (
            <Card1
              qrCodeRef={qrCodeRef}
              logo={logo}
              profile={profile}
              candidateName={candidateName}
              studentAdmission={studentAdmission}
              studentClass={studentClass}
              studentSection={studentSection}
              qrData={qrData}
              fathersName={fathersName}
              schoolName={schoolName}
              mobile={mobile}
              schoolMobile={schoolMobile}
              schoolAddress={schoolAddress}
            />
          ) : cardType == 4 ? (
            <Card2
              qrCodeRef={qrCodeRef}
              logo={logo}
              profile={profile}
              candidateName={candidateName}
              studentAdmission={studentAdmission}
              studentClass={studentClass}
              studentSection={studentSection}
              qrData={qrData}
              fathersName={fathersName}
              schoolName={schoolName}
              mobile={mobile}
              schoolMobile={schoolMobile}
              schoolAddress={schoolAddress}
            />
          ) : cardType == 3 ? (
            <Card3
              qrCodeRef={qrCodeRef}
              logo={logo}
              profile={profile}
              candidateName={candidateName}
              studentAdmission={studentAdmission}
              studentClass={studentClass}
              studentSection={studentSection}
              qrData={qrData}
              fathersName={fathersName}
              schoolName={schoolName}
              mobile={mobile}
              schoolMobile={schoolMobile}
              schoolAddress={schoolAddress}
            />
          ) : cardType == 2 ? (
            <Card4
              qrCodeRef={qrCodeRef}
              logo={logo}
              profile={profile}
              candidateName={candidateName}
              studentAdmission={studentAdmission}
              studentClass={studentClass}
              studentSection={studentSection}
              qrData={qrData}
              fathersName={fathersName}
              schoolName={schoolName}
              mobile={mobile}
              schoolMobile={schoolMobile}
              schoolAddress={schoolAddress}
            />
          ) : (
            <CardDefault
              qrCodeRef={qrCodeRef}
              logo={logo}
              profile={profile}
              company={company}
              mobile={mobile}
              candidateName={candidateName}
              studentAdmission={studentAdmission}
              studentClass={studentClass}
              studentSection={studentSection}
              displayNumber={displayNumber}
              qrData={qrData}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default IdCard;
